import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import MediaStreamRecorder, { StereoAudioRecorder } from 'msr';
import { makeCancelablePromise } from '../utils/promise-utils';

// note that this lib has a bug and does not broadcast onstop(), so we
//  record only one chunk - and the interval for recording
//  is actually the maximum recording length; then we handle onstop()
//  stuff in the ondataavailable() callback
//
//***************************************************************************************
export var AudioRecorder = function AudioRecorder(maxLengthMs) {
  var _this = this;

  _classCallCheck(this, AudioRecorder);

  this.setErrorHandler = function (errHandler) {
    _this.errorHandler = errHandler;
  };

  this.setStartedRecordingHandler = function (startedRecordingHandler) {
    _this.startedRecordingHandler = startedRecordingHandler;
  };

  this.setDoneRecordingHandler = function (doneRecordingHandler) {
    _this.doneRecordingHandler = doneRecordingHandler;
  };

  this.reset = function () {
    _this.stopRecording();
    if (_this.mediaRecorder) {
      _this.mediaRecorder.ondataavailable = function () {};
      _this.mediaRecorder = null;
    }
  };

  this.startRecording = function () {
    var userMediaPromise = navigator.mediaDevices.getUserMedia({ audio: true });
    _this.userMediaCancelablePromise = makeCancelablePromise(userMediaPromise);
    _this.userMediaCancelablePromise.promise.then(function (stream) {
      var mediaRecorder = _this.mediaRecorder;
      if (!mediaRecorder) {
        mediaRecorder = new MediaStreamRecorder(stream);
      }
      mediaRecorder.stream = stream;
      mediaRecorder.mimeType = 'audio/ogg';
      mediaRecorder.recorderType = StereoAudioRecorder;
      mediaRecorder.audioChannels = 2;
      mediaRecorder.ondataavailable = _this.handleDataAvailable;
      _this.mediaRecorder = mediaRecorder;

      _this.mediaRecorder.start(_this.maxLengthMs);
      _this.recording = true;
      _this.startedRecordingHandler();
    }).catch(_this.handleMediaError);
  };

  this.stopRecording = function () {
    if (!_this.mediaRecorder) {
      _this.userMediaCancelablePromise.cancel();
    } else {
      _this.mediaRecorder.stop();
    }
  };

  this.getAudioBlob = function () {
    return _this.audioBlob;
  };

  this.getAudioUri = function () {
    if (!_this.audioBlob) {
      _this.errorHandler('attempting to get audioUri when no audio is recorded');
      return '';
    }
    var blobURL = URL.createObjectURL(_this.audioBlob);
    return blobURL;
  };

  this.handleDataAvailable = function (blob) {
    // the test for recording is for the case where this hit the max
    //  and we want to call stop() but do not want to handle the
    //  subsequent call to this method which stop() will cause
    if (_this.recording) {
      _this.audioBlob = blob;
      _this.recording = false;
      _this.mediaRecorder.stop();
      _this.doneRecordingHandler();
    }
  };

  this.handleMediaError = function (err) {
    var errorMsg = 'media error: ' + err;
    _this.errorHandler(errorMsg);
  };

  this.audioBlob = null;
  this.mediaRecorder = null;
  this.maxLengthMs = maxLengthMs || 2 * 60 * 1000;
  this.recording = false;
  // best to replace this errorHandler with setErrorHandler()
  this.errorHandler = function (errMsg) {
    console.log(errMsg);
  };
  this.startedRecordingHandler = function () {};
  this.doneRecordingHandler = function () {};
}

// this is fired when the recorder reaches the end of its "interval"
//  which in our use means it has recorded the max amount and we are done with it
//  it is also fired when stop() is called on the recorder, and we are also done
;